import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {validateEmptyField} from '@evomatik/evk-common';
import {concatMap} from 'rxjs/operators';
import {FirmaElectronicaService} from "../../../services/firma-electronica.service";

let keyArrayBuffer;
let certArrayBuffer;

@Component({
    selector: 'evk-firma-electronica',
    templateUrl: './evk-firma-electronica.component.html',
    styleUrls: ['./evk-firma-electronica.component.scss'],
})
export class EvkFirmaElectronicaComponent implements OnInit, OnDestroy {


    /** Flag usado para el toggle de la visibilidad del campo contraseña */
    public hide = true;

    public cerificado: File;

    public llave: File;

    public formSign: FormGroup;


    /**
     * Datos Generación cadena backend
     */
    @Input() idDiligencia = '';

    @Input() username = '';

    /**
     * Hash del algoritmo para firmar
     */
    @Input() hash: string;

    /**
     * Mensaje a firmar
     */
    @Input() message: string;

    /**
     * Codificacion en la que se devilvera el mensaje firmado
     */
    @Input() signedMessageEncode: string;


    @Input() rfc: string;

    @Output() errorMessage: EventEmitter<EvkMessage> = new EventEmitter();
    @Output() signedMessage: EventEmitter<any> = new EventEmitter();
    @Output() valid: EventEmitter<boolean> = new EventEmitter();
    @Output() loading: EventEmitter<boolean> = new EventEmitter();
    @Output() serialNumber: EventEmitter<string> = new EventEmitter();


    subscription: any;

    constructor(
        public fb: FormBuilder,
        public firmaElectronicaService: FirmaElectronicaService,
    ) {


    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    ngOnInit() {
        this.formSign = this.formBuildSign;
        this.subscription = this.firmaElectronicaService.getLoadingEmitter()
            .subscribe(progress => {
                console.log(`Progress ${progress}.`);
                this.loading.emit(progress)
            });
    }

    private emitErrorMessage(message: string) {
        const errorMensaje: EvkMessage = {
            message,
        };
        this.errorMessage.emit(errorMensaje);
    }


    private emitLoading(loading: boolean) {
        this.loading.emit(loading);
    }

    public onFileSelected(event) {
        if (event.target.files.length > 0) {
            this.cerificado = event.target.files[0];
        }
    }

    protected get formBuildSign(): FormGroup {
        return this.fb.group({
            password: ['', [Validators.required, validateEmptyField]],
            certificado: ['', [Validators.required]],
            llave: ['', [Validators.required]],
        });
    }

    public handleFileSelect(evt) {
        evt.preventDefault();
        const f = evt.target.files[0];
        const reader = new FileReader();
        // Closure to capture the file information.
        reader.onload = ((theFile) => {
            return function (e) {
                if (theFile.name.endsWith('.key')) {
                    keyArrayBuffer = e.target.result;
                } else if (theFile.name.endsWith('.cer')) {
                    certArrayBuffer = e.target.result;
                }
                return e.target.result;
            };
        })(f);

        function errorHandler(evt: any) {
            switch (evt.target.error.code) {
                case evt.target.error.NOT_FOUND_ERR:
                    this.emitErrorMessage('Archivo no encontrado.');
                    break;
                case evt.target.error.NOT_READABLE_ERR:
                    this.emitErrorMessage('El archivo no se puede leer.');
                    break;
                case evt.target.error.ABORT_ERR:
                    break; // noop
                default:
                    this.emitErrorMessage(
                        'Ah ocurrido un error al leer el archivo.'
                    );
            }
        }

        reader.onerror = errorHandler;
        // LOS MODOS DE LECTURA DE HTML5
        reader.readAsArrayBuffer(f);
        // reader.readAsText(f, 'UTF-8');
    }


    /**
     *
     */
    public firmar() {

        this.loading.emit(true);
        const password = this.formSign.get(['password']).value;

        const pasos =
            this.firmaElectronicaService.validarCertificado(certArrayBuffer, keyArrayBuffer, password, this.hash, this.signedMessageEncode, this.rfc, this.message)
                .pipe(
                    concatMap(paso => paso)
                );

        pasos.subscribe({
            next: validacion => {
                console.log(validacion);
                //El paso 6 (ultimo) es el que envia la firma.
                if (validacion.firma) {
                    //una vez concluido los pasos de validacion
                    //se emite el objeto validacion como resultado
                    this.signedMessage.emit(validacion);
                    this.valid.emit(true);
                }
                if (validacion.serial) {
                    this.serialNumber.emit(validacion.serial);
                }
                if (validacion.rfc) {
                    this.rfc = validacion.rfc;
                }
            },
            error: err => {
                this.emitErrorMessage(err);
                this.loading.emit(false);
            },
            complete: () => {

                console.log('Se concluyen pasos de la validación del certificado digital.')
                this.loading.emit(false);
            }
        });


    }


}

export interface EvkMessage {
    message: string;
}
